import queryString from 'query-string';
import { compose, pathOr, prop } from 'ramda';

export const getRequestParam = paramName =>
	compose(prop(paramName), queryString.parse, pathOr('', ['location', 'search']));
